import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useTrackingManager } from '../useTrackingManager';
import type { CtaButtonProps } from './CtaBar';
import { getCtaLabel } from '../../lib/ctaLabel';

export type ClickHandler = (
  event: React.MouseEvent<HTMLElement>,
  cta: string,
  label: string,
) => unknown;

export type CtaCallbackButtonProps = CtaButtonProps & {
  clickHandler: ClickHandler;
};

export const CtaCallbackButton = ({
  variant,
  clickHandler,
  label,
  displayname,
  position,
  testId,
}: CtaCallbackButtonProps): React.ReactElement => {
  const trackingManager = useTrackingManager();
  return (
    <TextButton
      variant={variant}
      data-testid={testId || `pbc-cta-${position}`}
      onClick={(event) => {
        clickHandler(event, `${variant}-cta${position}`, label);
        trackingManager.click('exit_link', '', 'cta', label, displayname, position, label);
      }}
    >
      {getCtaLabel(label)}
    </TextButton>
  );
};
